import { Suspense, lazy, useMemo } from 'react';

import FilterDefault from 'app/components/Filter/FilterDefault';
import TableComponent from 'app/components/Table/TableComponent';
import { QUERIES } from 'app/components/Table/core/constants';
import { LoadingCard } from 'app/components/Table/loading/LoadingCard';

import MailHistoryFilter from 'app/modules/mail-history/components/MailHistoryFilter';
import { mailHistoryColumns } from 'app/modules/mail-history/core/columns';
import { DEFAULT_MAIL_TRACKING_TABLE_QUERY } from 'app/modules/mail-history/core/constants';
import { retrieveTrackedMailStats } from 'app/modules/mail-history/core/requests';
import { MainHeading } from 'app/modules/mail-history/core/styles';
import useMailHistory from 'app/modules/mail-history/hooks/useMailHistory';
import { useSyncQueryToState } from 'app/modules/query-state/hooks';

import omit from 'lodash/omit';

const ModalContent = lazy(() => import('app/modules/mail-history/components/ModalContent'));
const ModalRecipitent = lazy(() => import('app/modules/mail-history/components/ModalRecipitent'));

const MailHistoryPage = () => {
  useSyncQueryToState(location.pathname, DEFAULT_MAIL_TRACKING_TABLE_QUERY);

  const {
    data,
    isShow,
    setData,
    setIsShow,
    isLoadingResend,
    handleCloseModal,
    handleClickBodyTable,
    handleResendMailTracking,
    handleClickFilter,
    hasActiveFilters,
  } = useMailHistory();

  const columns = useMemo(
    () => mailHistoryColumns(setIsShow, setData, handleResendMailTracking),
    [setIsShow, setData, handleResendMailTracking],
  );

  return (
    <>
      <section className="py-8">
        <MainHeading>Mail Tracking</MainHeading>

        <TableComponent
          getList={retrieveTrackedMailStats}
          placeholderSearch="Search by organization, content or email"
          nameQuery={QUERIES.MAIL_TRACKING_LIST}
          originColumns={columns}
          syncParamUrl
          spacing="lg"
          isRowClickable={false}
          onClickBodyTable={handleClickBodyTable}
          customListHeader={
            <FilterDefault
              visible={isShow.filter}
              onClickFilter={handleClickFilter}
              isFilter={hasActiveFilters}
              content={
                isShow.filter && (
                  <MailHistoryFilter openFilter={isShow.filter} setIsOpenFilter={setIsShow} />
                )
              }
            />
          }
        />
      </section>

      <Suspense fallback={<LoadingCard />}>
        {isShow.content && (
          <ModalContent
            show={!!isShow.content}
            onClose={handleCloseModal}
            data={omit(data, 'recipient')}
          />
        )}
      </Suspense>

      <Suspense fallback={<LoadingCard />}>
        {isShow.recipient && (
          <ModalRecipitent
            show={!!isShow.recipient}
            onClose={handleCloseModal}
            data={data.recipient}
          />
        )}
      </Suspense>

      {isLoadingResend && <LoadingCard />}
    </>
  );
};

export default MailHistoryPage;
